/**
 * Pure navigation helpers extracted from object-detail for unit coverage.
 */

export function resolveObjectDetailBaseRoute(baseRoute: string): string {
    return baseRoute.startsWith('/') ? baseRoute : '/admin/' + baseRoute;
}

export function buildObjectUpdatePath(args: {
    urlParamKeys: string[];
    updateKeys?: string[];
    navigationKeyReplacements?: Record<string, string>;
    params: Record<string, string | undefined>;
    isAdminPath: boolean;
}): string {
    const urlKeys = args.updateKeys ? args.updateKeys : args.urlParamKeys;
    const urlParts = urlKeys.map(
        (key) =>
            '/' +
            (args.navigationKeyReplacements && args.navigationKeyReplacements[key] ? args.navigationKeyReplacements[key] + '/' : key.replace('Id', 's/')) +
            args.params[key]
    );
    const joined = urlParts.join('') + '/update';
    return args.isAdminPath ? '/admin' + joined : joined;
}
